export default __webpack_public_path__ + "static/powererd-db8e7ba33e1e446ba4eaa7876b040344.svg";